import React from 'react'
import { FormikProps, useFormikContext } from 'formik'
import {
  BoxV4,
  RadioButtonGroupMapping,
  RadioButtonType,
  RadioButtonsV2,
} from '@labrav/react-components'
import { Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRepeat } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './Renewal.styles'
import {
  MicrosoftFormFAQs,
  MicrosoftFormFAQsItem,
} from '../MicrosoftFormFAQs/MicrosoftFormFAQs'
import {
  FieldMetadata,
  FieldMetadataField,
} from '../../../../modules/privateOffer/types'
import { useSelector } from '../../../../store'
import { Product } from '../../../../modules/productsListing/types'

export const renewalOptions: RadioButtonGroupMapping[] = [
  {
    key: 'Yes',
    label: 'Yes',
    type: RadioButtonType.STANDARD,
  },
  {
    key: 'No',
    label: 'No',
    type: RadioButtonType.STANDARD,
  },
]

export const Renewal = ({ product }: { product: Product }) => {
  const { values, setFieldValue } = useFormikContext() as FormikProps<
    Record<string, unknown>
  >
  const { classes } = useStyles()

  const fieldMetadata = useSelector<FieldMetadata | undefined>(
    state =>
      state.privateOffersInCreation.currentPrivateOfferInCreation[
        product.productId
      ]?.fieldMetadata
  )

  const isRenewalReadOnly = (
    fieldMetadata?.existingContractRenewal as FieldMetadataField
  )?.readOnly

  const handleSelection = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value
    if (value === 'Yes') {
      await setFieldValue('existingContractRenewal', true)
    } else if (value === 'No') {
      await setFieldValue('existingContractRenewal', false)
    } else {
      await setFieldValue('existingContractRenewal', false)
    }
  }
  const checkedValue = () =>
    values.existingContractRenewal
      ? 'Yes'
      : values.existingContractRenewal === false
        ? 'No'
        : ''
  return (
    <div data-testid="renewal-section">
      <BoxV4
        heading={'Renewal'}
        headingIcon={
          <FontAwesomeIcon
            icon={faRepeat}
            style={{ width: '16px', height: '16px' }}
          />
        }
        secondaryActions={
          <MicrosoftFormFAQs item={MicrosoftFormFAQsItem.RENEWAL} />
        }
      >
        <div className={classes.sectionContainer}>
          <>
            <Typography className={classes.sectionText}>
              Is this offer intended to renew a current offer or an existing
              paid contract in effect within or outside of Commercial
              Marketplace?
            </Typography>
            <div className={classes.widthRadio}>
              <RadioButtonsV2
                checkedValue={{
                  key: checkedValue(),
                  value: checkedValue(),
                }}
                name={'existingContractRenewal'}
                handleChange={handleSelection}
                radioButtonMappings={renewalOptions.map(option => ({
                  ...option,
                  disabled: isRenewalReadOnly,
                }))}
              />
            </div>
          </>
        </div>
      </BoxV4>
    </div>
  )
}
